<div class="relative w-48 h-48 flex items-center justify-center rounded-full ">
    <svg class="absolute w-full h-full rotate-[-90deg]" viewBox="0 0 100 100">
      <circle
        [attr.class]="'transition-all duration-1000 ' + circleColor"
        cx="50"
        cy="50"
        r="45"
        stroke-width="6"
        stroke-linecap="round"
        stroke-dasharray="282.743"
        [attr.stroke-dashoffset]="(1 - progressPercentage / 100) * 282.743"
        fill="none"
      ></circle>
    </svg>
  
    <div class="text-3xl font-bold text-gray-700">
      {{ displayMinutes }}:<span>{{ displaySeconds }}</span>
    </div>
  </div>
  